import { useEffect } from 'react';
import HttpServices from 'src/services/httpService';
import { userModuleURL } from 'src/services/urlService';

const LinkedInCustomRedirect = () => {
  const popupWindowURL = new URL(window.location.href);
  const code = popupWindowURL.searchParams.get('code');
  const error = popupWindowURL.searchParams.get('error');
  const state = popupWindowURL.searchParams.get('state');
  const errorDescription = popupWindowURL.searchParams.get('error_description');

  useEffect(() => {
    if (code || error) {
      addAccessToken(code, state);
    }
  }, [code, error, state]); // include state in dependency array

  const addAccessToken = (code, state) => {
    const form = {
      code,
      integration_hash_id: state,
    };

    const postProps = {
      url: userModuleURL.addAccessToken,
      body: form,
      successCallback: (data, message) => {
        if (data?.url) {
          window.location.href = data.url; // redirect to the provided URL
        }
      },
      failureCallback: (errMessage) => {
        console.error('Access token error:', errMessage);
      },
    };

    HttpServices.Post(postProps);
  };

  return null;
};

export default LinkedInCustomRedirect;
